/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'validCircle': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M20 1.667C9.875 1.667 1.667 9.875 1.667 20c0 10.125 8.208 18.334 18.333 18.334 10.125 0 18.333-8.209 18.333-18.334S30.125 1.667 20 1.667zM27.947 16.9a1.666 1.666 0 10-2.56-2.133l-7.167 8.598-3.708-3.71a1.667 1.667 0 00-2.357 2.357l5 5a1.666 1.666 0 002.458-.112l8.334-10z" _fill="#15D14A"/>'
  }
})
